import logger from '@scale/frontend-lib/logging';
import getStatsCollector from 'react-scale/lib/metrics';

const NotificationsCollector = getStatsCollector('opshub.notifications');

interface User {
  _id: string;
  email: string;
}

interface MetricsTags {
  notificationId?: string;
  notificationSeverity?: string;
  notificationTitle?: string;
  source?: 'bell' | 'dropdown' | 'center';
  action?: 'click' | 'view_details' | 'view_all';
  userId?: string;
  userEmail?: string;
}

const logInfo = (message: string, user: User, tags?: MetricsTags): void => {
  logger.info(message, {
    ...tags,
    namespace: 'opshub.notifications',
    userId: user._id,
    userEmail: user.email,
  });
};

export const logNotificationBellClick = (user: User): void => {
  const tags: MetricsTags = {
    source: 'bell',
    action: 'click',
    userId: user._id,
    userEmail: user.email,
  };
  NotificationsCollector.incr('notification.bell.click', 1, tags as Record<string, string>);
  logInfo('User clicked notification bell', user, tags);
};

export const logViewAllClick = (user: User): void => {
  const tags: MetricsTags = {
    source: 'dropdown',
    action: 'view_all',
    userId: user._id,
    userEmail: user.email,
  };
  NotificationsCollector.incr('notification.view_all', 1, tags as Record<string, string>);
  logInfo('User clicked view all notifications', user, tags);
};

export const logNotificationClick = (
  notificationId: string,
  notificationSeverity: string,
  notificationTitle: string,
  source: 'dropdown' | 'center',
  user: User,
): void => {
  const tags: MetricsTags = {
    notificationId,
    notificationSeverity,
    notificationTitle,
    source,
    action: 'click',
    userId: user._id,
    userEmail: user.email,
  };
  NotificationsCollector.incr('notification.click', 1, tags as Record<string, string>);
  logInfo('User clicked notification', user, tags);
};

export const logTakeActionClick = (
  notificationId: string,
  notificationSeverity: string,
  notificationTitle: string,
  user: User,
): void => {
  const tags: MetricsTags = {
    notificationId,
    notificationSeverity,
    notificationTitle,
    source: 'center',
    action: 'view_details',
    userId: user._id,
    userEmail: user.email,
  };
  NotificationsCollector.incr('notification.take_action', 1, tags as Record<string, string>);
  logInfo('User clicked take action', user, tags);
};
